import FormattedMessage from 'I18n/components/FormattedMessage';
import AssociateContactToThreadButton from '../AssociateContactToThreadButton';
import CompanyName from 'svh-workspace-ui-lib/ticket-header/public/CompanyName';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DisplayDetails = ({
  associatedCompanyId,
  jobTitle,
  company,
  companyLink
}) => {
  if (jobTitle && company) {
    return /*#__PURE__*/_jsxs(Flex, {
      maxInlineSize: companyLink ? '' : '400px',
      children: [/*#__PURE__*/_jsx("span", {
        children: jobTitle
      }), /*#__PURE__*/_jsx(View, {
        paddingInlineStart: "100",
        paddingInlineEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.header.atLabel"
        })
      }), /*#__PURE__*/_jsx(CompanyName, {
        associatedCompanyId: associatedCompanyId,
        companyName: company,
        companyLink: companyLink
      })]
    });
  } else if (!jobTitle && company) {
    return /*#__PURE__*/_jsxs(Flex, {
      maxInlineSize: companyLink ? '' : '400px',
      children: [/*#__PURE__*/_jsx(View, {
        paddingInlineEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.header.fromLabel"
        })
      }), /*#__PURE__*/_jsx(CompanyName, {
        associatedCompanyId: associatedCompanyId,
        companyName: company,
        companyLink: companyLink
      })]
    });
  } else if (jobTitle && !company) {
    return /*#__PURE__*/_jsx("span", {
      children: jobTitle
    });
  }
  return null;
};
const CompanyDetails = ({
  associatedCompanyId,
  jobTitle,
  company,
  companyLink,
  isKnownContact,
  threadId
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    maxInlineSize: "max-content",
    children: isKnownContact ? /*#__PURE__*/_jsx(DisplayDetails, {
      associatedCompanyId: associatedCompanyId,
      jobTitle: jobTitle,
      company: company,
      companyLink: companyLink
    }) : /*#__PURE__*/_jsx(AssociateContactToThreadButton, {
      threadId: threadId
    })
  });
};
CompanyDetails.displayName = 'CompanyDetails';
DisplayDetails.displayName = 'DisplayDetails';
export default CompanyDetails;